import { CanvasDrawer } from "./CanvasDrawer";
import { CanvasImage, CanvasPropertyDict } from "./CanvasImage";
import localforage from 'localforage';
import { useStickerSectionStore } from "./EditorStore";

export const EditorCacheManager = {
    autoSaveInterval: null as NodeJS.Timeout | null,
    isAutoSaveEnabled: false,

    subscribeStore: function () {

        useStickerSectionStore.subscribe(
            (state) => state.showBackgroundImage,
            (newValue) => {
                localforage.setItem("showBackgroundImage", newValue);
            }
        );

        useStickerSectionStore.subscribe(
            (state) => state.backgroundColor,
            (newValue) => {
                localforage.setItem("backgroundColor", newValue);
            }
        );

        useStickerSectionStore.subscribe(
            (state) => state.ghostsEnabled,
            (newValue) => {
                localforage.setItem("ghostsEnabled", newValue);
            }
        );

        useStickerSectionStore.subscribe(
            (state) => state.ghostFreq,
            (newValue) => {
                localforage.setItem("ghostFreq", newValue);
            }
        );

        useStickerSectionStore.subscribe(
            (state) => state.ghostSize,
            (newValue) => {
                localforage.setItem("ghostSize", newValue);
            }
        );

        // Subscribe to ghostMode
        useStickerSectionStore.subscribe(
            (state) => state.ghostOpacity,
            (newValue) => {
                localforage.setItem("ghostOpacity", newValue);
            }
        );
    },

    startAutoSave: function () {
        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
        }

        this.isAutoSaveEnabled = true;
        console.log('Canvas auto-save started (30-second interval)');

        // Don't save immediately, wait for first interval
        this.autoSaveInterval = setInterval(() => {
            if (this.isAutoSaveEnabled) {
                this.saveCanvasState();
            }
        }, 5000);
    },

    // Stop auto-save
    stopAutoSave: function () {
        if (this.autoSaveInterval) {
            clearInterval(this.autoSaveInterval);
            this.autoSaveInterval = null;
        }
        this.isAutoSaveEnabled = false;
        console.log('Canvas auto-save stopped');
    },

    // Save current canvas state
    saveCanvasState: async function () {
        await this.cacheCanvasImages()

    },

    cacheCanvasImages: async function () {
        const canvasImages = CanvasDrawer.canvasImages;
        const previousCachedCanvasImageIDs = await localforage.getItem<string[]>("canvasImageIds") ?? [];

        // Remove all old cached items
        for (const id of previousCachedCanvasImageIDs) {
            await localforage.removeItem(id);
        }

        // Prepare new cache array
        const newCachedImageIds: string[] = [];

        // Cache new images and build list of IDs
        for (const canvasImage of canvasImages) {
            const id = canvasImage.itemID;
            newCachedImageIds.push(id);
            const canvasImagePropertyDict = canvasImage.getInstanceDict();
            await localforage.setItem(id, canvasImagePropertyDict);
        }

        // Save updated list of cached IDs
        await localforage.setItem("canvasImageIds", newCachedImageIds);
    },

    getCanvasImagesFromCache: async function () {
        const canvasImageIds = await localforage.getItem<string[]>("canvasImageIds") ?? []

        if (canvasImageIds.length === 0) {
            return;
        }

        const canvasImageDicts = await Promise.all(
            canvasImageIds.map(id => localforage.getItem(id) as Promise<CanvasPropertyDict | null>)
        );

        const BATCH_SIZE = 5;
        for (let i = 0; i < canvasImageDicts.length; i += BATCH_SIZE) {
            const batch = canvasImageDicts.slice(i, i + BATCH_SIZE);

            for (const canvasImagePropertyDict of batch) {
                if (canvasImagePropertyDict) {
                    const canvasImage = new CanvasImage(
                        canvasImagePropertyDict.imageID,
                        canvasImagePropertyDict.itemIndex,
                        canvasImagePropertyDict.TL_imageBounds,
                        canvasImagePropertyDict.BR_imageBounds,
                    );

                    canvasImage.rotation = canvasImagePropertyDict.rotation
                    canvasImage.flipped = canvasImagePropertyDict.flipped

                    CanvasDrawer.canvasImages.push(canvasImage)
                }
            }

            CanvasDrawer.rerenderCanvas();
        }
    },

};
